import PropTypes from 'prop-types'
import React from 'react'
import Alert from '../../molecules/Alert'
import * as validations from '../../../utils/validations'
import SelectField from '../../molecules/fields/SelectField'
import Value from '../../molecules/Value'
import { dataToOptions } from '../../../utils/helpers'
import useUserPermission from '../../../hooks/useUserPermission'
import { downgradeRoles, getTypeDescription } from '../../../configs/usersConfig'
import useToggle from '../../../hooks/useToggle'
import { useAllowedRoles } from '../../../hooks/useAllowedRoles'
import DialogCoordinatorErrorMessage from './DialogCoordinatorErrorMessage'
import { useField } from 'react-final-form'
import { useAuth } from '../../molecules/Auth'

export const UsersFieldRole = ({ initialValues, emailValidated, isNewUser }) => {
  const { user } = useAuth()
  const [openDialogToCollaborator, toggleOpenDialogToCollaborator] = useToggle(false)
  const { canEditManagePermission, canEditProfileType } = useUserPermission('user')
  const allowedRoles = useAllowedRoles()
  const { input } = useField('role')

  const handleConfirmChangeRole = confirm => {
    toggleOpenDialogToCollaborator()
    if (!confirm) {
      input.onChange(initialValues.role)
    }
  }

  const handleChangeRole = value => {
    if (downgradeRoles[user.role].includes(value)) {
      toggleOpenDialogToCollaborator()
    }
  }

  return (
    <>
      {!isNewUser && (
        <DialogCoordinatorErrorMessage
          open={openDialogToCollaborator}
          userEditId={initialValues.id}
          onClose={() => handleConfirmChangeRole(false)}
          onConfirm={() => handleConfirmChangeRole(true)}
        />
      )}
      <div className="flex flex-col md:flex-row">
        <SelectField
          name="role"
          label="Tipo de perfil"
          className="block md:w-96"
          size="2xl"
          options={dataToOptions(allowedRoles)}
          validate={validations.required()}
          disabled={!emailValidated || !canEditProfileType}
          margin={canEditManagePermission ? 'lowdense' : 'normal'}
          onChange={handleChangeRole}
        />
        <Value name="role">
          {({ value }) => {
            const typeDescription = getTypeDescription(value)
            return typeDescription ? (
              <Alert type="info" className="md:ml-4 md:mt-8 md:w-72 lg:w-125 xl:w-148 w-full" border hideIcon>
                {typeDescription}
              </Alert>
            ) : null
          }}
        </Value>
      </div>
    </>
  )
}

UsersFieldRole.propTypes = {
  initialValues: PropTypes.object,
  emailValidated: PropTypes.bool,
  isNewUser: PropTypes.bool
}
